import { StateCreator } from 'zustand'

import { Objective } from '../types'

interface ObjectivesState {
  objectives: Objective[]
}

interface ObjectivesActions {
  addObjective: (objective: Objective) => void
  setObjectives: (objectives: Objective[]) => void
}

export type ObjectivesSlice = ObjectivesState & ObjectivesActions

export const initialObjectivesState: ObjectivesState = {
  objectives: [],
}

const createObjectivesSlice: StateCreator<ObjectivesSlice, [], [], ObjectivesSlice> = (
  set,
  get,
) => ({
  ...initialObjectivesState,
  addObjective: (objective) => set((state) => ({ objectives: [...state.objectives, objective] })),
  setObjectives: (objectives) => {
    const prevObjectives = get().objectives
    if (JSON.stringify(prevObjectives) !== JSON.stringify(objectives)) {
      set({ objectives })
    }
  },
})

export default createObjectivesSlice
